import TYPES from '../product-types';
import { DIR } from 'core/constants';
import Copy from '@resn/gozer-core/copy';

import xs1Colors from '../xs1-colors';
import xs1Packages from '../xs1-packages';

export default [
    // ************************************************************
    //
    // XS1
    //
    // ************************************************************

    // XS1 FLEX
    {
        id: 'xs1-flex-black',
        type: TYPES.XS1,
        color: xs1Colors.find((color) => color.id == 'black'),
        package: xs1Packages.find((pack) => pack.id == 'flex'),
        // remove cart
        // cartTitle: Copy.get('cart-xs1-item-flex'),
        // cartDesc: Copy.get('cart-xs1-item-flex-desc'),
        // cartImage: `${DIR.IMG}products/cart/xs1-black-thumb.png`,
        gallery: [
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-black-1.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-black-1-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-black-2.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-black-2-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-black-3.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-black-3-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-black-4.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-black-4-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-black-5.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-black-5-optimized@small.png`,
            },
            { type: 'video', src: `${DIR.VIDEO}xs1-configure-gallery.mp4` },
        ],
        thumbs: [
            `${DIR.IMG}products/xs1/xs1-configure-your-black-thumb-1.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-black-thumb-2.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-black-thumb-3.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-black-thumb-4.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-black-thumb-5.png`,
            `${DIR.IMG}general/play-video-thumb.png`,
        ],
    },
    {
        id: 'xs1-flex-black-silver',
        type: TYPES.XS1,
        color: xs1Colors.find((color) => color.id == 'black-silver'),
        package: xs1Packages.find((pack) => pack.id == 'flex'),
        // remove cart
        // cartTitle: Copy.get('cart-xs1-item-flex'),
        // cartDesc: Copy.get('cart-xs1-item-flex-desc'),
        // cartImage: `${DIR.IMG}products/cart/xs1-grey-thumb.png`,
        gallery: [
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-grey-1.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-grey-1-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-grey-2.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-grey-2-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-grey-3.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-grey-3-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-grey-4.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-grey-4-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-grey-5.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-grey-5-optimized@small.png`,
            },
            { type: 'video', src: `${DIR.VIDEO}xs1-configure-gallery.mp4` },
        ],
        thumbs: [
            `${DIR.IMG}products/xs1/xs1-configure-your-grey-thumb-1.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-grey-thumb-2.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-grey-thumb-3.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-grey-thumb-4.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-grey-thumb-5.png`,
            `${DIR.IMG}general/play-video-thumb.png`,
        ],
    },
    {
        id: 'xs1-flex-grey-rose',
        type: TYPES.XS1,
        color: xs1Colors.find((color) => color.id == 'grey-rose'),
        package: xs1Packages.find((pack) => pack.id == 'flex'),
        // remove cart
        // cartTitle: Copy.get('cart-xs1-item-flex'),
        // cartDesc: Copy.get('cart-xs1-item-flex-desc'),
        // cartImage: `${DIR.IMG}products/cart/xs1-rose-thumb.png`,
        gallery: [
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-white-1.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-white-1-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-white-2.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-white-2-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-white-3.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-white-3-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-white-4.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-white-4-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-white-5.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-white-5-optimized@small.png`,
            },
            { type: 'video', src: `${DIR.VIDEO}xs1-configure-gallery.mp4` },
        ],
        thumbs: [
            `${DIR.IMG}products/xs1/xs1-configure-your-white-thumb-1.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-white-thumb-2.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-white-thumb-3.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-white-thumb-4.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-white-thumb-5.png`,
            `${DIR.IMG}general/play-video-thumb.png`,
        ],
    },
    // XS1 FLOW
    {
        id: 'xs1-flow-black',
        type: TYPES.XS1,
        color: xs1Colors.find((color) => color.id == 'black'),
        package: xs1Packages.find((pack) => pack.id == 'flow'),
        // remove cart
        // cartTitle: Copy.get('cart-xs1-item-flow'),
        // cartDesc: Copy.get('cart-xs1-item-flow-desc'),
        // cartImage: `${DIR.IMG}products/cart/xs1-black-thumb.png`,
        gallery: [
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-black-1.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-black-1-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-black-2.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-black-2-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-black-3.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-black-3-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-black-4.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-black-4-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-black-5.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-black-5-optimized@small.png`,
            },
            { type: 'video', src: `${DIR.VIDEO}xs1-configure-gallery.mp4` },
        ],
        thumbs: [
            `${DIR.IMG}products/xs1/xs1-configure-your-black-thumb-1.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-black-thumb-2.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-black-thumb-3.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-black-thumb-4.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-black-thumb-5.png`,
            `${DIR.IMG}general/play-video-thumb.png`,
        ],
    },
    {
        id: 'xs1-flow-black-silver',
        type: TYPES.XS1,
        color: xs1Colors.find((color) => color.id == 'black-silver'),
        package: xs1Packages.find((pack) => pack.id == 'flow'),
        // remove cart
        // cartTitle: Copy.get('cart-xs1-item-flow'),
        // cartDesc: Copy.get('cart-xs1-item-flow-desc'),
        // cartImage: `${DIR.IMG}products/cart/xs1-grey-thumb.png`,
        gallery: [
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-grey-1.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-grey-1-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-grey-2.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-grey-2-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-grey-3.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-grey-3-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-grey-4.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-grey-4-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-grey-5.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-grey-5-optimized@small.png`,
            },
            { type: 'video', src: `${DIR.VIDEO}xs1-configure-gallery.mp4` },
        ],
        thumbs: [
            `${DIR.IMG}products/xs1/xs1-configure-your-grey-thumb-1.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-grey-thumb-2.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-grey-thumb-3.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-grey-thumb-4.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-grey-thumb-5.png`,
            `${DIR.IMG}general/play-video-thumb.png`,
        ],
    },
    {
        id: 'xs1-flow-grey-rose',
        type: TYPES.XS1,
        color: xs1Colors.find((color) => color.id == 'grey-rose'),
        package: xs1Packages.find((pack) => pack.id == 'flow'),
        // remove cart
        // cartTitle: Copy.get('cart-xs1-item-flow'),
        // cartDesc: Copy.get('cart-xs1-item-flow-desc'),
        // cartImage: `${DIR.IMG}products/cart/xs1-rose-thumb.png`,
        gallery: [
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-white-1.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-white-1-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-white-2.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-white-2-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-white-3.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-white-3-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-white-4.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-white-4-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-white-5.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-white-5-optimized@small.png`,
            },
            { type: 'video', src: `${DIR.VIDEO}xs1-configure-gallery.mp4` },
        ],
        thumbs: [
            `${DIR.IMG}products/xs1/xs1-configure-your-white-thumb-1.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-white-thumb-2.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-white-thumb-3.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-white-thumb-4.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-white-thumb-5.png`,
            `${DIR.IMG}general/play-video-thumb.png`,
        ],
    },
    // XS1 FORM
    // {
    //     id: 'xs1-form-black',
    //     type: TYPES.XS1,
    //     color: xs1Colors.find((color) => color.id == 'black'),
    //     package: xs1Packages.find((pack) => pack.id == 'form'),
    //     cartTitle: Copy.get('cart-xs1-item-form'),
    //     cartDesc: Copy.get('cart-xs1-item-form-desc'),
    //     cartImage: `${DIR.IMG}products/cart/xs1-black-thumb.png`,
    //     gallery: [
    //         {type: 'img', src: `${DIR.IMG}products/xs1/xs1-configure-your-black-1.png`},
    //         {type: 'img', src: `${DIR.IMG}products/xs1/xs1-configure-your-black-2.png`},
    //         {type: 'img', src: `${DIR.IMG}products/xs1/xs1-configure-your-black-3.png`},
    //         {type: 'img', src: `${DIR.IMG}products/xs1/xs1-configure-your-black-4.png`},
    //         {type: 'img', src: `${DIR.IMG}products/xs1/xs1-configure-your-black-5.png`},
    //     ],
    //     thumbs: [
    //         `${DIR.IMG}products/xs1/xs1-configure-your-black-thumb-1.png`,
    //         `${DIR.IMG}products/xs1/xs1-configure-your-black-thumb-2.png`,
    //         `${DIR.IMG}products/xs1/xs1-configure-your-black-thumb-3.png`,
    //         `${DIR.IMG}products/xs1/xs1-configure-your-black-thumb-4.png`,
    //         `${DIR.IMG}products/xs1/xs1-configure-your-black-thumb-5.png`,
    //     ],
    // },
    // {
    //     id: 'xs1-form-black-silver',
    //     type: TYPES.XS1,
    //     color: xs1Colors.find((color) => color.id == 'black-silver'),
    //     package: xs1Packages.find((pack) => pack.id == 'form'),
    //     cartTitle: Copy.get('cart-xs1-item-form'),
    //     cartDesc: Copy.get('cart-xs1-item-form-desc'),
    //     cartImage: `${DIR.IMG}products/cart/xs1-grey-thumb.png`,
    //     gallery: [
    //         {type: 'img', src: `${DIR.IMG}products/xs1/xs1-configure-your-grey-1.png`},
    //         {type: 'img', src: `${DIR.IMG}products/xs1/xs1-configure-your-grey-2.png`},
    //         {type: 'img', src: `${DIR.IMG}products/xs1/xs1-configure-your-grey-3.png`},
    //         {type: 'img', src: `${DIR.IMG}products/xs1/xs1-configure-your-grey-4.png`},
    //         {type: 'img', src: `${DIR.IMG}products/xs1/xs1-configure-your-grey-5.png`},
    //     ],
    //     thumbs: [
    //         `${DIR.IMG}products/xs1/xs1-configure-your-grey-thumb-1.png`,
    //         `${DIR.IMG}products/xs1/xs1-configure-your-grey-thumb-2.png`,
    //         `${DIR.IMG}products/xs1/xs1-configure-your-grey-thumb-3.png`,
    //         `${DIR.IMG}products/xs1/xs1-configure-your-grey-thumb-4.png`,
    //         `${DIR.IMG}products/xs1/xs1-configure-your-grey-thumb-5.png`,
    //     ],
    // },
    // {
    //     id: 'xs1-form-grey-rose',
    //     type: TYPES.XS1,
    //     color: xs1Colors.find((color) => color.id == 'grey-rose'),
    //     package: xs1Packages.find((pack) => pack.id == 'form'),
    //     cartTitle: Copy.get('cart-xs1-item-form'),
    //     cartDesc: Copy.get('cart-xs1-item-form-desc'),
    //     cartImage: `${DIR.IMG}products/cart/xs1-rose-thumb.png`,
    //     gallery: [
    //         {type: 'img', src: `${DIR.IMG}products/xs1/xs1-configure-your-white-1.png`},
    //         {type: 'img', src: `${DIR.IMG}products/xs1/xs1-configure-your-white-2.png`},
    //         {type: 'img', src: `${DIR.IMG}products/xs1/xs1-configure-your-white-3.png`},
    //         {type: 'img', src: `${DIR.IMG}products/xs1/xs1-configure-your-white-4.png`},
    //         {type: 'img', src: `${DIR.IMG}products/xs1/xs1-configure-your-white-5.png`},
    //     ],
    //     thumbs: [
    //         `${DIR.IMG}products/xs1/xs1-configure-your-white-thumb-1.png`,
    //         `${DIR.IMG}products/xs1/xs1-configure-your-white-thumb-2.png`,
    //         `${DIR.IMG}products/xs1/xs1-configure-your-white-thumb-3.png`,
    //         `${DIR.IMG}products/xs1/xs1-configure-your-white-thumb-4.png`,
    //         `${DIR.IMG}products/xs1/xs1-configure-your-white-thumb-5.png`,
    //     ],
    // },
    // XS1 PEAK
    {
        id: 'xs1-peak-black',
        type: TYPES.XS1,
        color: xs1Colors.find((color) => color.id == 'black'),
        package: xs1Packages.find((pack) => pack.id == 'peak'),
        // remove cart
        // cartTitle: Copy.get('cart-xs1-item-peak'),
        // cartDesc: Copy.get('cart-xs1-item-peak-desc'),
        // cartImage: `${DIR.IMG}products/cart/xs1-black-thumb.png`,
        gallery: [
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-black-1.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-black-1-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-black-2.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-black-2-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-black-3.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-black-3-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-black-4.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-black-4-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-black-5.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-black-5-optimized@small.png`,
            },
            { type: 'video', src: `${DIR.VIDEO}xs1-configure-gallery.mp4` },
        ],
        thumbs: [
            `${DIR.IMG}products/xs1/xs1-configure-your-black-thumb-1.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-black-thumb-2.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-black-thumb-3.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-black-thumb-4.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-black-thumb-5.png`,
            `${DIR.IMG}general/play-video-thumb.png`,
        ],
    },
    {
        id: 'xs1-peak-black-silver',
        type: TYPES.XS1,
        color: xs1Colors.find((color) => color.id == 'black-silver'),
        package: xs1Packages.find((pack) => pack.id == 'peak'),
        // remove cart
        // cartTitle: Copy.get('cart-xs1-item-peak'),
        // cartDesc: Copy.get('cart-xs1-item-peak-desc'),
        // cartImage: `${DIR.IMG}products/cart/xs1-grey-thumb.png`,
        gallery: [
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-grey-1.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-grey-1-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-grey-2.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-grey-2-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-grey-3.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-grey-3-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-grey-4.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-grey-4-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-grey-5.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-grey-5-optimized@small.png`,
            },
            { type: 'video', src: `${DIR.VIDEO}xs1-configure-gallery.mp4` },
        ],
        thumbs: [
            `${DIR.IMG}products/xs1/xs1-configure-your-grey-thumb-1.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-grey-thumb-2.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-grey-thumb-3.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-grey-thumb-4.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-grey-thumb-5.png`,
            `${DIR.IMG}general/play-video-thumb.png`,
        ],
    },
    {
        id: 'xs1-peak-grey-rose',
        type: TYPES.XS1,
        color: xs1Colors.find((color) => color.id == 'grey-rose'),
        package: xs1Packages.find((pack) => pack.id == 'peak'),
        // remove cart
        // cartTitle: Copy.get('cart-xs1-item-peak'),
        // cartDesc: Copy.get('cart-xs1-item-peak-desc'),
        // cartImage: `${DIR.IMG}products/cart/xs1-rose-thumb.png`,
        gallery: [
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-white-1.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-white-1-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-white-2.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-white-2-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-white-3.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-white-3-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-white-4.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-white-4-optimized@small.png`,
            },
            {
                type: 'img',
                src: `${DIR.IMG}products/xs1/xs1-configure-your-white-5.png`,
                srcMobile: `${DIR.IMG}products/xs1/optimized/xs1-configure-your-white-5-optimized@small.png`,
            },
            { type: 'video', src: `${DIR.VIDEO}xs1-configure-gallery.mp4` },
        ],
        thumbs: [
            `${DIR.IMG}products/xs1/xs1-configure-your-white-thumb-1.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-white-thumb-2.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-white-thumb-3.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-white-thumb-4.png`,
            `${DIR.IMG}products/xs1/xs1-configure-your-white-thumb-5.png`,
            `${DIR.IMG}general/play-video-thumb.png`,
        ],
    },
];
